import { Component, inject, OnInit } from '@angular/core';
import { HubRecordEditorBase } from '../../_hub_record_editor_base';
import { ProjectFinanceProjectModel } from '../../../../../hub_schema/hubTypes';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LinkWorkdayProjectsDialogComponent } from './link-workday-projects-dialog/link-workday-projects-dialog.component';
import { take } from 'rxjs';

@Component({
    selector: 'app-workday-projects-panel',
    templateUrl: './workday-projects-panel.component.html',
    styleUrl: './workday-projects-panel.component.scss',
    standalone: false
})
export class WorkdayProjectsPanelComponent extends HubRecordEditorBase implements OnInit {
    private dialogService: MatDialog = inject(MatDialog);
    public activeProjectFinanceProjects: ProjectFinanceProjectModel[] | undefined;
    public archivedProjectFinanceProjects: ProjectFinanceProjectModel[] | undefined;

    public ngOnInit(): void {
        this.refreshFinanceProjects();
    }

    private refreshFinanceProjects(): void {
        const projectFinanceProjects = this.projectEditForm?.controls.projectFinanceProjects.value as ProjectFinanceProjectModel[];

        // debugger;
        this.activeProjectFinanceProjects = projectFinanceProjects.filter(pfp => !pfp.isArchived)
            .sort((prev, curr) => new Date(curr.createdOn!).getTime() - new Date(prev.createdOn!).getTime());

        this.archivedProjectFinanceProjects = projectFinanceProjects.filter(pfp => pfp.isArchived)
            .sort((prev, curr) => new Date(curr.createdOn!).getTime() - new Date(prev.createdOn!).getTime());
    }

    public archiveFinanceProjectLink(pfp: ProjectFinanceProjectModel): void {
        pfp.isArchived = true;
        this.refreshFinanceProjects();
        this.projectEditForm!.controls.projectFinanceProjects.markAsDirty();
    }

    public activateFinanceProjectLink(pfp: ProjectFinanceProjectModel): void {
        pfp.isArchived = false;
        this.refreshFinanceProjects();
        this.projectEditForm!.controls.projectFinanceProjects.markAsDirty();
    }

    public addWorkdayLink(): void {
        const dialogRef: MatDialogRef<LinkWorkdayProjectsDialogComponent> = this.dialogService.open(LinkWorkdayProjectsDialogComponent, {
            width: '80vw',
            maxWidth: 'none',
            height: '90vh'
        });
        dialogRef.afterClosed().pipe(take(1)).subscribe(() => {
            this.refreshFinanceProjects();
        });
    }

    public deleteWorkdayLink(projectFinanceProject: ProjectFinanceProjectModel): void {
        const projectFinanceProjects = this.projectEditForm!.controls.projectFinanceProjects.value
            .filter((pfp: ProjectFinanceProjectModel) => pfp.financeProjectId !== projectFinanceProject.financeProjectId);

        this.projectEditForm!.controls.projectFinanceProjects.setValue(projectFinanceProjects);
        this.projectEditForm!.controls.projectFinanceProjects.markAsDirty();
        this.projectEditForm!.controls.projectFinanceProjects.updateValueAndValidity();
        this.refreshFinanceProjects();
    }
}
